export const buttonColor = Object.freeze({
  default: {
    class: 'btn-default-theme'
  },
  red: {
    class: 'btn-red-theme'
  },
  green: {
    class: 'btn-green-theme'
  },
  blue: {
    class: 'btn-blue-theme'
  }
});
